import { render, staticRenderFns } from "./StockMaterial.vue?vue&type=template&id=ba8c377c"
import script from "./StockMaterial.vue?vue&type=script&lang=js"
export * from "./StockMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports